<template>
    <div class="o-subscriptions">
        <m-title title="Dostępne pakiety" />
        <div class="l-row">
            <div class="m-tabs">
                <a-button
                    v-for="item in fetchBoundles"
                    v-bind:key="item.symbol"
                    class="m-tabs__tab o-subscriptions__packages"
                    :class="{
                        'a-button--grey': item.id !== tempSubscription.id
                    }"
                    @click="setTempSubscription(item)"
                >
                    {{ item.name }}
                </a-button>
            </div>
        </div>
        <div
            v-if="tempSubscription && tempSubscription.description"
            class="l-row"
        >
            <div class="l-row__column">
                <p class="a-text">Dlaczego warto?</p>
                <div v-html="tempSubscription.description" class="a-text"></div>
            </div>
        </div>
        <div v-if="cards && cards.length > 0" class="l-row">
            <div class="l-row__column">
                <h2 class="a-title a-title--black">Wybierz pakiet</h2>
            </div>
        </div>
        <div>
            <div
                v-if="cards && cards.length > 0"
                class="o-subscriptions__cards"
                :class="{ 'slider-active': sliderActive }"
            >
                <OSlider :settings="carouselSettings">
                    <div
                        v-for="(card, index) in cards"
                        :key="index"
                        class="o-subscriptions__cardWrapper"
                    >
                        <div
                            class=" o-subscriptions__card "
                            :class="{
                                'slider-active': sliderActive,
                                'o-subscriptions__card--promotion':
                                    card.discount_from && card.discount_to,
                                'o-subscriptions__card--active':
                                    card.id === activeCard.id
                            }"
                            @click="setTempSubscriptionPackage(card)"
                        >
                            <p class="o-subscriptions__cardMonthsValue">
                                {{ card.time_amount }}
                            </p>
                            <p class="o-subscriptions__cardMonthsText">
                                mies.
                            </p>
                            <hr class="o-subscriptions__divider" />
                            <p class="o-subscriptions__priceValue">
                                {{ card.price }} {{ card.currency.symbol }}
                            </p>
                            <p class="o-subscriptions__pricePerMonthValue">
                                <strong
                                    >{{
                                        pricePerMonth(
                                            card.net_price,
                                            card.time_amount
                                        )
                                    }}
                                    {{ card.currency.symbol }}</strong
                                >
                                / mies.
                            </p>
                            <div
                                v-if="activeCard.id === card.id"
                                class="o-subscriptions__cardDot"
                            ></div>
                        </div>
                    </div>
                </OSlider>
            </div>
            <div v-else class="l-row">
                <div class="l-row__column">
                    <p class="a-text ">Brak pakietów.</p>
                </div>
            </div>
        </div>
        <div v-if="!isEmployee" class="l-row">
            <div class="l-row__column">
                <a-button
                    v-if="activeCard !== null && isNewSubscriptionTimeAvailable"
                    class="o-menu__button o-subscriptions__button"
                    type="fullwidth"
                    @click="$router.push({ name: 'subscriptionsPayments' })"
                    :disabled="!activeCard.id"
                    >Kontynuuj</a-button
                >
                <p
                    v-else-if="!isNewSubscriptionTimeAvailable"
                    class="m-card__container a-text o-subscriptions__timeAvailable"
                >
                    Pakiet aktywny do:
                    <strong>{{ activeSubscription.activeTo }}</strong>
                    <br /><br />
                    Zakup pakietu jest możliwy najszybciej 14 dni przed
                    zakończeniem aktualnie aktywnego pakietu.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import OSlider from '@/components/global/OSlider.vue'
export default {
    name: 'subscriptionsList',
    components: { OSlider },
    data() {
        return {
            tempSubscriptionPackage: '',
            activeCard: {}
        }
    },
    computed: {
        userRoles() {
            return this.$store.getters.authUserRole
        },
        sliderActive() {
            return this.cards.length > 3
        },
        carouselSettings() {
            return {
                centerMode: true,
                arrows: true,
                dots: true,
                focusOnSelect: true,
                infinite: true,
                speed: 500,
                slidesToShow: this.sliderActive ? 3 : this.cards.length,
                slidesToScroll: 1,
                centerPadding: this.sliderActive ? '15px' : '30px',
                responsive: [
                    {
                        breakpoint: 340,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        },
        cards() {
            return (
                this.tempSubscription.discounted_period_prices &&
                this.tempSubscription.discounted_period_prices.filter(
                    e => e.is_active
                )
            )
        },
        fetchBoundles() {
            return this.$store.getters['subscriptions/boundles']
        },
        tempSubscription() {
            return this.$store.getters['subscriptions/tempSubscription']
        },
        activeSubscription() {
            return this.$store.getters['subscriptions/activeSubscription']
        },
        isNewSubscriptionTimeAvailable() {
            const computedEnd = this.$dayjs(
                this.activeSubscription.activeTo
            ).subtract(14, 'days')
            return this.$dayjs().isAfter(computedEnd)
        },
        isEmployee() {
            return this.userRoles.some(role => role.symbol === 'admin' || role.symbol === 'employee')
        }
    },
    methods: {
        setTempSubscriptionPackage(subscriptionPackage) {
            this.activeCard = subscriptionPackage
            this.$store.dispatch(
                'subscriptions/setTempSubscriptionPackage',
                subscriptionPackage
            )
        },
        setTempSubscription(subscriptionPackage) {
            this.$store.dispatch(
                'subscriptions/setTempSubscription',
                subscriptionPackage
            )
        },
        setActiveSubscription(subscription) {
            this.$store.dispatch('subscriptions/setSubscription', subscription)
        },
        pricePerMonth(price, months) {
            const sum = price / months
            return sum.toFixed(2)
        }
    },
    async created() {
        try {
            await this.$store.dispatch(
                'subscriptions/fetchSubscriptionBoundles'
            )
            if (this.fetchBoundles[0].id) {
                this.setTempSubscription(this.fetchBoundles[0])
            }
        } catch (error) {
            console.log(error)
        }
    },
    mounted() {
        this.tempSubscriptionPackage = this.tempSubscription
    }
}
</script>
